import React from "react";
import {
    List, DateField,
    Datagrid,
    TextField, FunctionField
} from "react-admin";
import { Box } from "@mui/material";

/* ================= MAIN LIST ================= */

const PujaPaymentsList = (props) => (
    <Box sx={{ mt: 4 }}>
        <List
            {...props}
        >
            <Datagrid rowClick="show">
                <TextField source="paymentName" label="Puja Name" />
                {/* <TextField source="amount" /> */}
                <FunctionField
                    label="Amount"
                    render={(record) =>
                        `${record.currencyType || ""} ${record.amount || 0}`
                    }
                />
                <TextField source="firstPaymentMode" label="Payment Method" />
                <TextField source="paymentStatus" />
                <DateField source="date" showTime />
            </Datagrid>
        </List>
    </Box>
);

export default PujaPaymentsList;
export const PujaPaymentsShow = PujaPaymentsList;
